import CityPageTemplate from "../city-template/CityPageTemplate";
import { arlingtonConfig } from "./data";

export default function ArlingtonPage() {
  return <CityPageTemplate config={arlingtonConfig} />;
}